<template>

    <div class="c-flight-panel__flight-information-filters">
        <div class="c-flight-panel__flight-information-radio">
            <form class="c-flight-panel__flight-information-radio-list">
                <div class="radios" v-for="(option,index) in options" :key="option.value">
                    <input :name="this.status"
                           type="radio"
                           :id="option.value + this.status + componentId"
                           :value="option.value"
                           v-model="selectedOption"
                           @change="flightDirection">
                    <label :for="option.value + this.status + componentId">{{ option.label }}</label>
                </div>
            </form>
        </div>
        <div class="c-flight-panel__flight-information-search">
            <span class="c-flight-panel__flight-information-search-button iconf-search"></span>
            <input class="c-flight-panel__flight-information-search-input" type="text" v-model="searchText" placeholder="Search your flight number" />
        </div>
    </div>
    <div class="c-flight-panel__flight-information-listing">

        <!-- Header Row -->
        <div class="c-flight-panel__flight-information-item">
            <div class="c-flight-panel__flight-information-flight">Flight No.</div>
            <div class="c-flight-panel__flight-information-origin" v-if="status === 'Arrival'">Arriving from</div>
            <div class="c-flight-panel__flight-information-origin" v-if="status === 'Departure'">Departing to</div>
            <div class="c-flight-panel__flight-information-time">Time</div>
            <div class="c-flight-panel__flight-information-status on-time">Status</div>
        </div>

        <!-- Loop through the filtered list of flights and display each one-->
        <div v-for="item in filteredList" class="c-flight-panel__flight-information-item" v-if="filteredList.length > 0 && nodata === false">
            <div class="c-flight-panel__flight-information-flight">
                <div class="c-flight-panel__flight-information-airline">
                    <img v-if="item.flightDesignation.includes('JQ')" src="../flags/ic-jetStar.png" alt="jetStar" />
                    <img v-else-if="item.flightDesignation.includes('QF')" src="../flags/ic-qantas.png" alt="qantasTail" />
                    <img v-else-if="item.flightDesignation.includes('VA')" src="../flags/ic-virgin.png" alt="virginTail" />
                    <!--<img v-else-if="item.flightDesignation.includes('EK')" src="../flags/ic-emirates.png" alt="emirates" />-->
                    <img v-else src="../flags/ic-airNz.png" alt="airNz" />
                </div>
                <div class="c-flight-panel__flight-information-number desktop-only">
                    <div v-for="flight in item.flightList">{{flight}}</div>
                </div>
            </div>

            <div class="c-flight-panel__flight-information-number mobile-only">
                <div v-for="flight in item.flightList">{{flight}}</div>
            </div>

            <div class="c-flight-panel__flight-information-origin" v-if="status === 'Arrival'">{{item.from}}</div>
            <div class="c-flight-panel__flight-information-origin" v-if="status === 'Departure'">{{item.destination}}</div>

            <div class="c-flight-panel__flight-information-time">
                <span class="mobile-only">Time: </span> {{item.dateTime.format('HH:mm')}}
            </div>
            <div class="c-flight-panel__flight-information-status on-time">{{item.status}}</div>
        </div>

        <!-- Display if there are no flights to show -->
        <div v-else-if="nodata === false" class="c-flight-panel__flight-information-item">
            No Flights Found.
        </div>

        <div v-if="nodata" class="c-flight-panel__flight-information-item">
            Flights currently unavailable.
        </div>

    </div>
    <div class="c-flight-panel__flight-information-panel-footer">
        <a :href="contactinfo" v-if="contactinfo" class="c-flight-panel__flight-information-contact">Airline <span>Contact</span> Info</a>

        <a :href="arrivalsdepartures"
           class="c-flight-panel__flight-information-view-all"
           v-if="status === 'Arrival' && arrivalsdepartures"
           @click.prevent="redirectWithQuery">
            <span>View</span> All Arrivals
        </a>
        <a :href="arrivalsdepartures"
           class="c-flight-panel__flight-information-view-all"
           v-if="status === 'Departure' && arrivalsdepartures"
           @click.prevent="redirectWithQuery">
            <span>View</span> All Departures
        </a>
    </div>

    <div class="c-flight-updated">
        Last updated {{ lastUpdated }}
    </div>

</template>

<script>
    import { ref } from 'vue';
    import moment from 'moment-timezone';

    export default {
        name: 'flightinfosmall',
        props: {
            contactinfo: String,
            arrivalsdepartures: String,
            lastUpdated: String
        },
        data() {
            return {
                componentId: `flight-${Math.random().toString(36).substr(2, 9)}`,
                flightArrivalInfo: [],
                flightDepartureInfo: [],
                FlightList: [],
                status: '',
                options: [
                    { label: 'All', value: 'All' },
                    { label: 'Domestic', value: 'Domestic' },
                    { label: 'International', value: 'International' }
                ],
                selectedOption: 'All',
                searchText: '',
                timer: null,
                nodata: false
            }
        },
        mounted() {
            // Call the method immediately upon component mount
            this.flightInfo();

            // Set up the interval to call method every 10 minutes (600,000 milliseconds)
            this.timer = setInterval(this.flightInfo, 10 * 60 * 1000);

            // Attach event listener to the document when the component is mounted to check for external clicks
            document.addEventListener('click', this.handleExternalClick);

            // Read data-updated-at from the root element
            const root = this.$el;
            if (root && root.getAttribute) {
                this.lastUpdated = root.getAttribute('data-updated-at') || '';
            }
        },
        beforeUnmount() {
            // Clear the interval when the component is about to be unmounted to prevent memory leaks
            clearInterval(this.timer);

            // Clean up the event listener when the component is unmounted to prevent memory leaks
            document.removeEventListener('click', this.handleExternalClick);
        },
        watch: {

        },
        computed: {
            filteredList() {

                let flights = Array.from(this.FlightList);

                // Return the original list if the search box is empty and limit to 7
                if (!this.searchText) {
                    return flights.slice(0, 7);
                }

                // Else apply text filtering and then limit to seven
                if (this.searhText !== '') {

                    const searchTerm = this.searchText.toLowerCase();

                    const FilteredFlights = flights.filter(item => {

                        // Check if ANY of the object's string values contain the search term
                        return Object.values(item).some(value => {
                            // Only check string values and convert to lowercase for comparison
                            if (typeof value === 'string') {
                                return value.toLowerCase().includes(searchTerm);
                            } else if (Array.isArray(value)) {
                                var stringValue = value.join(' ').toLowerCase();
                                return stringValue.includes(searchTerm);
                            }
                            return false;
                        });
                    });

                    return FilteredFlights.slice(0, 7);
                }
            },
        },
        methods: {
            async flightInfo() {

                var MakeDate = (event) => {
                    var date = event.schDate;
                    var time = event.schTime.split('.')[0];

                    var dateTime = moment(date + 'T' + time);

                    event.dateTime = dateTime;

                    return event;
                }

                // Fetch arrival flight data from the API
                const arrivalApi = '/api/flights/arrivals';

                try {
                    const response = await fetch(arrivalApi); // Replace with your API endpoint
                    if (!response.ok) {
                        this.nodata = true;
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();

                    this.flightArrivalInfo = data.map(x => MakeDate(x));

                } catch (error) {
                    this.nodata = true;
                    console.error('Error fetching data:', error);
                }

                // Fetch departure flight data from the API
                const departureApi = '/api/flights/departures';

                try {
                    const response = await fetch(departureApi); // Replace with your API endpoint
                    if (!response.ok) {
                        this.nodata = true;
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();

                    this.flightDepartureInfo = data.map(x => MakeDate(x));

                } catch (error) {
                    this.nodata = true;
                    console.error('Error fetching data:', error);
                }

                this.flightDirection();

            },
            flightDirection() {

                // Retrieve data for arrivals and departures
                let arrivals = this.flightArrivalInfo;
                let departures = this.flightDepartureInfo;

                let ArrivalButton = document.getElementById("ArrivalsButton");
                let DepartureButton = document.getElementById("DeparturesButton");

                // Determine which button is active and set FlightDetails accordingly
                if (ArrivalButton.classList.contains('active')) {
                    this.flightLocal(arrivals);
                    this.status = 'Arrival';
                }

                if (DepartureButton.classList.contains('active')) {
                    this.flightLocal(departures);
                    this.status = 'Departure';
                }
            },
            flightLocal(Flights) {

                // Filter FlightDetails based on the selected radio button option
                if (this.selectedOption === 'All') {

                    this.flightSorted(Flights);

                } else if (this.selectedOption === 'Domestic') {

                    this.flightSorted(Flights.filter(local => local.isDomestic === true));

                } else if (this.selectedOption === 'International') {

                    this.flightSorted(Flights.filter(local => local.isDomestic === false));

                }
            },
            flightSorted(Flights) {

                // makes small helper function to convert date and time strings to Date object
                var MakeDate = (event) => {
                    var date = event.estDate;
                    var time = event.estTime.split('.')[0];

                    var dateTime = moment.tz(date + 'T' + time, 'Pacific/Auckland');

                    return (dateTime);
                }

                // Sorts the flights by date and time
                var Flightsorted = Flights.sort((a, b) => { return MakeDate(a) - MakeDate(b) });

                var Now = moment.tz('Pacific/Auckland');

                // Filters out past flights and only show today's flights
                var Future = Flightsorted.filter(event => {
                    // Use the MakeDate function to get the Date object for comparison
                    const eventDate = MakeDate(event);
                    var isFuture = eventDate >= Now;
                    var isToday = eventDate.isSame(Now, 'day');

                    return isFuture && isToday;
                });

                // Add flightDesignation field to each item in FutureFlights
                Future.forEach(item => {
                    // Remove numbers using a regular expression
                    const cleanedString = item.flightList[0].toString().replace(/[0-9]/g, '');
                    // Add the new field to the item
                    item.flightDesignation = cleanedString;
                });

                this.FlightList = Future;
            },
            handleExternalClick(event) {

                // Check if the click was on either the Arrivals or Departures button
                let ArrivalButton = document.getElementById("ArrivalsButton");
                let DepartureButton = document.getElementById("DeparturesButton");

                // If the click was on either button, call flightDirection to update the flight list
                if (event.target === ArrivalButton || event.target === DepartureButton) {
                    this.flightInfo();
                }
            },
            redirectWithQuery(event) {
                // Prevent the default link behavior
                event.preventDefault();
                // Get the current search text
                const query = this.status;
                // Construct the new URL with the query parameter
                const url = new URL(this.arrivalsdepartures, window.location.origin);
                if (query) {
                    url.searchParams.set('status', query);
                }
                // Redirect to the new URL
                window.location.href = url.toString();
            },
        },
    };
</script>
